import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { User } from './types'

interface AuthState {
  status: 'checking' | 'authenticated' | 'anonymous' | 'error' | 'expired'
  user: User | null
}

const initialState: AuthState = {
  status: 'checking',
  user: null,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    checking(state) { state.status = 'checking' },
    failed(state) { state.status = 'error' },
    expired(state) { state.status = 'expired' },
    authenticated(state, action: PayloadAction<User>) {
      state.status = 'authenticated'
      state.user = action.payload
    },
    anonymous(state) {
      state.status = 'anonymous'
      state.user = null
    },
  },
})

export const authActions = authSlice.actions
